import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '@odo/shared-ui';

interface AddressPillProps {
    address: string;
}

// Truncates a long email/address in a pill, full value on hover via Tooltip
// (title as a no-JS fallback).
export function AddressPill({ address }: AddressPillProps) {
    return (
        <Tooltip content={address} side="top">
            <span
                title={address}
                className="inline-flex items-center gap-1.5 max-w-[220px] px-2.5 py-1 rounded-full bg-white border border-gray-200 shadow-sm text-xs font-medium text-gray-700 hover:border-gray-300 hover:bg-gray-50 transition-colors"
            >
                <EnvelopeIcon className="h-3 w-3 text-gray-400 flex-shrink-0" />
                <span className="truncate">{address}</span>
            </span>
        </Tooltip>
    );
}
